import { Box, Typography } from "@mui/material";

export function Title() {
  return (
    <Typography
      variant="h1"
      sx={{ color: "white", textAlign: "center", paddingBottom: "10px", fontFamily: "arial", my: 2 }}
    >
      UBCNotes
    </Typography>
  );
}
